<template>
  <div
    class="d-flex-column justify-start align-start gap-20"
    style="margin-top: 12px"
  >
    <h4 class="t-white font-family-1 title-h5 f-w-600">
      {{ $t("dashboard.achievements") }}
    </h4>

    <div
      class="d-flex-column select_honor_picker justify-start align-start gap-24"
    >
      <div class="achievement_grid">
        <button
          class="picker_option d-flex-row gap-16"
          v-for="packOption in items"
          :key="packOption"
          @click.stop="() => selectOption(packOption)"
          :class="[isSelectedAchievement(packOption) && 'selected']"
        >
          <p class="t-white medium-l font-family-2 white-space-no">
            {{ packOption.title }}
          </p>
          <Tooltip :text="$t(packOption.description)" :position="'top'">
            <PoiIcon />
          </Tooltip>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import Tooltip from "~/components/custom/Tooltip.vue";
import PoiIcon from "~/components/icons/PoiIcon.vue";

const gameStore = useGameStore();
const userStore = useUserStore();
const checkoutStore = useCheckoutStore();
const items = computed(() => {
  const pps = gameStore.getGamePack.prices || [];
  if (pps.length > 0) {
    return pps;
  }
  return [];
});

const isSelectedAchievement = (option) => {
  const optionsSelected = checkoutStore.getSelectedBadges || [];
  if (optionsSelected.includes(option.slab)) {
    return true;
  }
  return false;
};

const selectOption = (option) => {
  checkoutStore.setBadges({
    badgeId: option.slab,
  });
};
</script>

<style lang="scss" scoped>
.achievement_grid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(auto, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;

  @media screen and (max-width: 1440px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
